import { XMarkIcon } from '@heroicons/react/24/outline';

interface PracticeChipProps {
    /** Falls back to the id (muted) when the practice has no name on file. */
    name: string | null;
    id: string;
    onRemove?: () => void;
}

export function PracticeChip({ name, id, onRemove }: PracticeChipProps) {
    const label = name ?? id;
    return (
        <span
            className={`inline-flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full h-6 text-[11px] font-semibold whitespace-nowrap max-w-[172px] ${
                onRemove ? 'pl-2 pr-1' : 'px-2'
            }`}
        >
            <span className={`truncate ${name ? 'text-gray-700' : 'text-gray-400'}`}>{label}</span>
            {onRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    aria-label={`Remove ${label}`}
                    className="w-4 h-4 rounded-full hover:bg-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-900 shrink-0"
                >
                    <XMarkIcon className="h-2.5 w-2.5" />
                </button>
            )}
        </span>
    );
}
